import { render, staticRenderFns } from "./ResponseInstruction.vue?vue&type=template&id=68fbc85d&lang=pug"
import script from "./ResponseInstruction.vue?vue&type=script&lang=js"
export * from "./ResponseInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports